import { PublicClientApplication } from "@azure/msal-browser";
import * as config from "./config";

export const msalConfig = {
  auth: {
    tenant: config.tenant,
    clientId: config.clientId,
    authority: `https://login.microsoftonline.com/${config.tenant}`,
    redirectUri: window.location.origin,
    endpoints: {
      api: config.clientId,
    },
    origin: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage", // "sessionStorage"
  },
};

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile"],
};
export const authContext = new PublicClientApplication(msalConfig);
